import DropdownTreeSelect from "react-dropdown-tree-select";
import "./styles.css";

const TreeSelect = ({label , data , onChange , ...rest}) => {
    const handleChange = (currentNode, selectedNodes) => {
        const selectedIds = selectedNodes.map((node) => {
            return node.id;
        } );
        onChange(selectedIds);
    }

    return (
        <div className="card">
            <div className="card-body">
                {label && <label className="card-title mb-2">{label}</label>}
                <DropdownTreeSelect keepTreeOnSearch={true} className={'bootstrap-demo'} data={data} onChange={handleChange} {...rest} />
            </div>
        </div>
    );
}

export const TreeSelectWithoutContainer = ({label , data , onChange , ...rest}) => {
    const handleChange = (currentNode, selectedNodes) => {
        const selectedIds = selectedNodes.map((node) => {
            return node.value;
        } );
        onChange(selectedIds);
    }

    return (
        <div className="">
            {label && <label className="card-title mb-2">{label}</label>}
            <DropdownTreeSelect keepTreeOnSearch={true} className={'bootstrap-demo'} data={data} onChange={handleChange} {...rest} />
        </div>
    );
}

export default TreeSelect;